module.exports = __webpack_public_path__ + "static/img/ysh.9f760da.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ysh.svg
// module id = g/q1
// module chunks = 1 2